import GeneralSummaryControlStyle from "./GeneralSummaryControl.module.scss";
import GeneralSummaryStyle from "./../GeneralSummary/GeneralSummary.module.scss";
import CirclePointDiagramStyle from "./../CirclePointDiagram/CirclePointDiagram.module.scss";
import HighlightedValueStyle from "./../HighlightedValue/HighlightedValue.module.scss";
import  * as React from "react";
import { observer } from "mobx-react";
import { GeneralSummary } from "./../GeneralSummary/GeneralSummary"
import { CirclePointDiagram } from "./../CirclePointDiagram/CirclePointDiagram"
import { IGeneralSummaryControlParams } from "./IGeneralSummaryControlParams";
import { HighlightedValue } from "./../HighlightedValue/HighlightedValue";

@observer
export class GeneralSummaryControl extends React.Component<IGeneralSummaryControlParams>{
    constructor(props: IGeneralSummaryControlParams) {
        super(props, undefined);
    }
    
    render() {
        if (!this.props.testResult)
            return <div></div>;

        return <div className={`${GeneralSummaryControlStyle.GeneralSummaryControl} row`}>
            <div className="col-xs-4">
                <p className={GeneralSummaryControlStyle.infoText}>Combine Info</p>
                <GeneralSummary 
                    className={GeneralSummaryStyle.GeneralSummary} 
                    player={this.props.player} 
                    testResult={this.props.testResult} 
                    ball={this.props.ball} 
                    reportDate={this.props.reportDate} 
                    unitPresentation={this.props.unitPresentation} 
                    numberOfDeletedStrokes={this.props.testResult.statistics.numberOfDeletedStrokes} 
                    reportKind={this.props.reportKind}/>
            </div>
            <div className="col-xs-4">
                <p className={GeneralSummaryControlStyle.infoText}>Combine Score</p>
                <CirclePointDiagram 
                    className={CirclePointDiagramStyle.CirclePointDiagram} 
                    combineScore={this.props.testResult.statistics.avgScore} />
            </div>
            <div className="col-xs-4">
                <p className={GeneralSummaryControlStyle.infoText}>Estimated Handicap</p>
                <HighlightedValue 
                    className={HighlightedValueStyle.HighlightedValue} 
                    estimatedHandicap={this.props.testResult.statistics.avgScore} />
            </div>
        </div>;
    }
}
